import React, { useState } from "react";
import Subtotal from "./Main";

const DEFAULT_VALUE = {
  value: "20.30123",
  warning: null,
  message: 'Testing'
}

const Demo = () => {
  const [value, setValue] = useState({...DEFAULT_VALUE})

  return (
    <>
      <Subtotal
        value={value}
        // show_message={true}
      />
      <br/>
      {value && <ul>
        <li>Value: {value.value}</li>
      </ul>}
    </>
  )
}

export default Demo;
